import { c as _c } from "react/compiler-runtime";
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectIsMiniMapMode } from '@repo/store/maps/slices/clientContext';
import { selectIsInCreatorMode, selectMapId } from '@repo/store/maps/slices/mapData';
import { AddCustomLocation } from './add-custom-location';
import { AddMapLocation } from './add-map-location';
import { CompactLayerButton } from './compact-layer-button';
import { MoveMapLocation } from './move-map-location';
import { type LiveLocationCtaControl, PlayerLocationButton } from './player-location-button';
import { ResetOrientationButton } from './reset-orientation-button';
import { ZoomControls } from './zoom-controls';
interface MapControlsProps {
  hideLayerControl?: boolean;
  liveLocationCta?: LiveLocationCtaControl;
}
export const MapControls = t0 => {
  const $ = _c(23);
  const {
    hideLayerControl: t1,
    liveLocationCta
  } = t0;
  const hideLayerControl = t1 === undefined ? false : t1;
  const isInCreatorMode = useAppSelector(selectIsInCreatorMode);
  const isMiniMapMode = useAppSelector(selectIsMiniMapMode);
  const mapId = useAppSelector(selectMapId);
  let t2;
  if ($[0] !== isMiniMapMode || $[1] !== liveLocationCta || $[2] !== mapId) {
    t2 = mapId && <PlayerLocationButton mapId={mapId} hidden={isMiniMapMode} liveLocationCta={liveLocationCta} />;
    $[0] = isMiniMapMode;
    $[1] = liveLocationCta;
    $[2] = mapId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isMiniMapMode) {
    t3 = !isMiniMapMode && <ResetOrientationButton />;
    $[4] = isMiniMapMode;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isMiniMapMode) {
    t4 = !isMiniMapMode && <ZoomControls />;
    $[6] = isMiniMapMode;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== hideLayerControl || $[9] !== isMiniMapMode) {
    t5 = !isMiniMapMode && !hideLayerControl && <CompactLayerButton />;
    $[8] = hideLayerControl;
    $[9] = isMiniMapMode;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isInCreatorMode || $[12] !== isMiniMapMode) {
    t6 = !isInCreatorMode && !isMiniMapMode && <AddCustomLocation />;
    $[11] = isInCreatorMode;
    $[12] = isMiniMapMode;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isInCreatorMode) {
    t7 = isInCreatorMode && <><AddMapLocation /><MoveMapLocation /></>;
    $[14] = isInCreatorMode;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <FlexRow justify="center" align="end" gap="16"><FlexColumn height="full" gap="8" justify="end" alignSelf="end">{t2}{t3}{t4}{t5}{t6}{t7}</FlexColumn></FlexRow>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};